import command_center from './command_center';
import monitoring from './monitoring';

export default {
  ...command_center,
  ...monitoring,
};
